<div class="betslip-edit-bet_screen-container betslip-vars-scope" *ngIf="state$ | async as state" [ngSwitch]="state.base.state">
    <div class="betslip-edit-bet_screen__result" *ngSwitchCase="BetslipStates.Result">
        <bs-betslip-edit-mybet-result-header (closeButtonClick)="closeResultClick()"></bs-betslip-edit-mybet-result-header>
        <bs-digital-result
            [state]="state.result"
            [trackingInformation]="trackingInformation"
            [inColumn]="inColumn"
            [showResultActions]="false"
            [oddsDisplayFormat]="oddsDisplayFormat$ | async"
            [isNavigationFromEditBet]="true"></bs-digital-result>

        <ng-container *msShowInEpcot="{ showInEpcot: true, module: module }">
            <div class="betslip-edit-bet-screen__result-button" *ngIf="!inColumn">
                <button class="btn btn-primary" (click)="closeResultClick()">{{ sitecore.globalMessages.Close }}</button>
            </div>
        </ng-container>
    </div>
    <bs-betslip-edit-mybet *ngSwitchDefault [inColumn]="inColumn"></bs-betslip-edit-mybet>
</div>
